import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Box, Typography, Paper } from '@mui/material';

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading, isAdmin } = useAuth();
  const location = useLocation();
  
  // If still loading auth state, show loading state
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <Typography>Loading...</Typography>
      </Box>
    );
  }
  
  // If not authenticated, redirect to login
  if (!user) {
    const redirect = encodeURIComponent(`${location.pathname}${location.search || ''}`);
    return <Navigate to={`/login?redirect=${redirect}`} replace />;
  }
  
  // If admin access is required but user is not admin, show access denied
  if (adminOnly && !isAdmin()) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <Paper elevation={3} sx={{ p: 4, textAlign: 'center', maxWidth: 400 }}>
          <Typography variant="h5" color="error" gutterBottom>
            Access Denied
          </Typography>
          <Typography variant="body1" color="text.secondary">
            You don't have administrator privileges to access this page.
          </Typography>
          <Typography variant="body2" sx={{ mt: 2 }}>
            Contact your system administrator if you believe this is an error.
          </Typography>
        </Paper>
      </Box>
    );
  }
  
  // User is authenticated (and is admin if required), render the protected component
  return children;
};

export default ProtectedRoute;
